import { createContext } from 'react';

export const DisableContext = createContext(false);
